
import Typography from '@mui/material/Typography';


export const TextDrugAtazanavir = () => {

return(
<div>
    
<Typography variant="h6" >
<br />


Atazanavir is used along with other medications to treat human immunodeficiency virus (HIV) infection 
in adults and children who are at least 3 months of age and weigh at least 22 lb (10 kg). #
Atazanavir is in a class of medications called protease inhibitors. It works by decreasing the amount of HIV in the blood. 
Although atazanavir does not cure HIV, it may decrease your chance of developing acquired immunodeficiency syndrome (AIDS) and HIV-related illnesses 
such as serious infections or cancer. Atazanavir must be given with other medications that treat HIV infection to completely treat the infection. 
Taking these medications along with practicing safer sex and making other lifestyle changes may decrease 
the risk of transmitting the HIV virus to other people.

<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a603019.html

</Typography>

</div>

)
}